export const KARGO_DIV_ID_PRODUCTION = 'div-gpt-ad-1627414400139-0'
export const KARGO_DIV_ID_TEST = 'div-gpt-ad-1623686651191-0'
